export default {
  travelling: '✈️',
  'payments-getting-started': '💰',
  'switching-to-monzo': '💯',
  'payments-troubleshooting': '🤔',
  'account-and-profile': '👤',
  'monzo-with-friends': '👩‍❤️‍👩',
  'legal-stuff': '⚖️',
  'joint-accounts': '👯‍♀️',
  emergencies: '🚨',
  crowdfunding: '❤️',
  'monzo-card-pin': '💳',
  'budgeting-overdrafts-savings': '📊',
  'app-help': '📱',
  'business-accounts': '💼',
  default: '💬',
};
